import { getTimezoneName } from '@calendly/timezone-tools'
import { BodyText } from '@calendly/ui/components/typography'

import { DateSpecificRulesReadOnly } from 'components/availability/form/date_specific_rules'


import { DateSpecificHours } from './date_specific_hours'
import { IntervalsSection } from './intervals_section'
import { ReadOnlyHoursView } from './read_only_hours_view'
import { TimezoneDropdown } from './timezone_dropdown'
import { PanelContentContainer } from '../../../styles'

export const HoursAndDateOverrides = ({
  isManaged = false,
  formPath,
  fixTimezonePositioning,
  readOnly
}) => (
  <PanelContentContainer>
    <IntervalsSection
      formPath={formPath}
      readOnly={readOnly}
    />
    <TimezoneDropdown
      isManaged={isManaged}
      formPath={formPath}
      readOnly={readOnly}
      fixTimezonePositioning={fixTimezonePositioning}
    />
    <DateSpecificHours
      formPath={formPath}
      readOnly={readOnly}
    />
  </PanelContentContainer>
)

export const ReadOnlyHoursAndDateOverrides = ({
  availableHours,
  timezone,
  dateOverrides
}) => (
  <PanelContentContainer>
    <ReadOnlyHoursView
      days={availableHours}
    />
    <BodyText size="small">{getTimezoneName(timezone)}</BodyText>
    <DateSpecificRulesReadOnly
      days={availableHours}
      dates={dateOverrides}
      timezone={timezone}
      redesignStyling
      compact
    />
  </PanelContentContainer>
)
